/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * PageTitle.tsx
 */

import React from 'react';
import HiloReactComponent from "./HiloReactComponent";
import {LabelAccessor} from "../LabelAccessor";
import NavigationService from "../../service/NavigationService";

export interface TitleTab {
    title: LabelAccessor;
    content: any;
}

interface Props {
    title: LabelAccessor;
    tabs?: TitleTab[];
    onTabSelected?: (index: number) => void;
    backLabel?: LabelAccessor;
    subTitle?: string;
}

interface State {
    currentTabIndex?: number;
}

export default class PageTitle extends HiloReactComponent<Props, State> {
    private _navigationService : NavigationService;

    constructor(props: Props, state: State) {
        super(props, state);

        this._navigationService = this._serviceRepository.resolve(NavigationService.id) as NavigationService;

        this.state = {
            currentTabIndex: 0
        }
    }

    /**
     * _handleTabClick
     * @param index
     * @private
     */
    private _handleTabClick(index: number) {
        this.setState({currentTabIndex: index});
        this.props.onTabSelected?.(index);
    }

    /**
     * render
     * @returns {any}
     */
    public render() {
        const {title, tabs, backLabel, subTitle} = this.props;
        const {currentTabIndex} = this.state;

        return <>
            <header className="page-title-container">
                <h1>{title(this.t)}</h1>
                <div className={"tabs"}>
                    {
                        tabs?.map((tab, index) => {
                            const selected = index === currentTabIndex;

                            return <div className={`tab ${selected ? 'selected' : ''}`}
                                        onClick={() => this._handleTabClick(index)}
                                        key={index}>
                                <p>{tab.title(this.t)}</p>
                            </div>;
                        })
                    }
                </div>
            </header>
            {backLabel && <p onClick={(e) => this._navigationService.goToParentPage()}
                             className={"page-title-back no-select"}><span>&lt;</span>{backLabel(this.t)}</p>}
            {subTitle && <p className={"page-title-sub no-select"}>{subTitle}</p>}
        </>;
    }
}